import React from "react";
import { Classes } from "@blueprintjs/core";
import { ISectionPartProps } from "../../models";
import { getAlignmentClass } from "../../models/utils";
//import { Orientation, ContentAlignment } from "../../models/baseTypes";
import classnames from "classnames";
import css from "../../form.module.scss";


const SectionPart: React.FC<ISectionPartProps> = ({ alignment, style, children, title } ) => {
  const classes = classnames(css.formPart, css.section);
  const alignmentClass = getAlignmentClass(alignment);
  return (
    <div style={style} className={classes} >
        {title && <div className={Classes.RUNNING_TEXT}><blockquote><h3>{title}</h3></blockquote></div>}
        <div className={alignmentClass}>
          {children}
        </div>
    </div>
  );
}

export default SectionPart;
